import React, { useEffect } from "react";
import Auth from "../components/Auth/Auth";
import { appendGTMHeader, removeGTMScript } from "../utils/GoogleGTM";
import SeoHead from "./../components/SeoHead";

export default function LoginPage() {
  useEffect(() => {
    const sc = appendGTMHeader();

    return () => {
      removeGTMScript(sc);
    };
  }, []);

  return (
    <>
      <SeoHead pageName="Login" />
      <Auth />
    </>
  );
}
